import React, { useEffect, useContext } from 'react';

import {
    Container,
    Typography,
    Button
} from '@material-ui/core';

import {
} from '../../common';

import {
} from './components';

import { PageProvider, PageContext } from './PageContext';
import { NavContext, NavRoutes } from '../../contexts';
import { MenuContext } from '../../contexts';

import homepageImage from '../../../images/scextmetadata-homepage.png'

import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
    root: {
        textAlign: "center"
    }
}));

const PageContent = (props) => {
    const classes = useStyles();

    const {
        state,
        pageIsReady,
        setPageIsReady,
        isBusy,
        setIsBusy
    } = useContext(PageContext);

    const {
        state: { menuIsOpen },
        setMenuIsOpen
    } = useContext(MenuContext);

    const viewTablesClickHandler = (e) => {
        setMenuIsOpen(!menuIsOpen);
    }

    return (
        <Container maxWidth="md" className={classes.root}>
            <Typography variant="h4">
                Structured extra SAP information
            </Typography>
            <br />
            <Button variant="contained"
                onClick={viewTablesClickHandler}>
                View tables
            </Button>
            <br /><br />
            <img src={homepageImage} alt="homepage image" />
        </Container>
    );
}

export const HomePage = () => {

    return (
        <PageProvider>
            <PageContent />
        </PageProvider>
    );
}